import { bytecloudAsyncJwtService, currentDomainID, gatewayJwtService } from "@bytecloud/common-lib";
import { TccProxy } from "@bytecloud/core-lib";
import { getAPIVolcEnv } from "./volc/request";
import { globalConfig } from "./config";
import { checkAndClearSignInTokenExpireTimeStorage } from "./utils/login-status";
import { LoginSessionExpiredBehavior } from "./volcengine-iframe-types";
import { bytecloudContext } from "./bytecloud/context";
import { getVolcCommonOrigin } from "./volc/util";
function getGatewayDomainId(volcEnv) {
  if (currentDomainID === "sinf" && volcEnv === "online") {
    return "online";
  }
  if (currentDomainID === "sinfi18n" && volcEnv === "byteplus") {
    return "i18n-bd";
  }
  if (currentDomainID !== "sandbox" && volcEnv === "stable") {
    console.warn("[Bytecloud]当前控制面 %s 不支持登录火山stable，已降级至sandbox", currentDomainID);
    return "sandbox";
  }
  return currentDomainID;
}
async function getGotoVolcUrl(redirect, accountId) {
  const { volcConfig } = globalConfig;
  const jwtInfo = await bytecloudAsyncJwtService.getJwtInfoByDomainID(
    volcConfig.enabled ? volcConfig.redirectDomainID : "sinf"
  );
  const jwt = await gatewayJwtService.getJwt(jwtInfo.uniqueKey);
  let baseUrl;
  if (["sinf", "sinf-boe", "sinfi18n", "sinfonlinea"].includes(globalConfig.cloudSite || "")) {
    baseUrl = `${location.origin}/auth/api/v1`;
  } else {
    baseUrl = jwtInfo.baseUrl;
  }
  const volcAccountId = accountId;
  let href = `${baseUrl}/goto_volc?redirect=${encodeURIComponent(redirect)}&x-jwt-token=${encodeURIComponent(jwt)}`;
  if (volcAccountId !== void 0) {
    href += `&volc-account-id=${encodeURIComponent(volcAccountId)}`;
  }
  return href;
}
async function gotoVolc(redirect, accountId, target = "_blank", features, volcEnv = "online") {
  const targetUrl = new URL(redirect);
  targetUrl.hostname = new URL(getVolcCommonOrigin(volcEnv)).hostname;
  const href = await getGotoVolcUrl(targetUrl.href, accountId);
  window.open(new URL(href), target, features);
}
const policyTCCProxy = new TccProxy({
  namespace: "bytecloud.fe.config",
  key: "volc_permission_apply_list",
  hostname: location.hostname,
  fetchStrategy: "staleWhileRevalidate",
  defaultValue: {},
  validator(value) {
    try {
      return Boolean(value);
    } catch (error) {
      return false;
    }
  }
});
function getProxyAddHeader({
  jwt = "",
  volcAccountId = "",
  volcEnv = "online",
  hijackVolcConsoleAPI = false,
  productType,
  injectPSM = "",
  injectTRN = "",
  hostname = "",
  resourceBytetree,
  volcProxyGW = false,
  signCookieVersion = 1,
  customHeader = {},
  samlType = "user"
}) {
  const headerObject = {
    "x-jwt-token": jwt,
    "x-bcgw-producttype": productType,
    "x-bcgw-sts-type": "samlSts",
    "x-bcgw-sinf-account-id": volcAccountId,
    "x-bcgw-accountmeta": `main_account_id=${volcAccountId}`,
    "x-bcgw-resource-bytetree": resourceBytetree ? String(resourceBytetree) : "",
    "volc-env": getAPIVolcEnv(volcEnv),
    "x-iam-psm": injectPSM,
    "x-iam-trn": injectTRN,
    "x-cloud-volc-api-proxy": volcProxyGW ? "gw" : "no-gw",
    "x-cloud-volc-saml-type": samlType,
    ...customHeader
  };
  if (hijackVolcConsoleAPI) {
    if (signCookieVersion === 2 || samlType === "role") {
      headerObject["x-bcgw-volc-sign-cookie-v2"] = "true";
    } else {
      headerObject["x-bcgw-volc-sign-cookie"] = "true";
    }
  }
  if (hostname) {
    headerObject["x-bcgw-volc-sign-hostname"] = hostname;
  }
  return headerObject;
}
function getDefaultHijackTopSource(hijackVolcConsoleAPI, selfHostedVolcEndPoint) {
  if (selfHostedVolcEndPoint) {
    return hijackVolcConsoleAPI ? `^(${selfHostedVolcEndPoint})?/api` : `^(${selfHostedVolcEndPoint})?/api/top`;
  } else {
    return hijackVolcConsoleAPI ? "^/api" : "^/api/top";
  }
}
async function clearExpireTimeCacheAndRefresh(volcService, onLoginSessionExpired) {
  var _a, _b;
  if (!volcService.iframeUrlManager) {
    throw new Error("iframeUrlManager is not initialized. There may be issues in the initialization process.");
  }
  const options = await volcService.iframeUrlManager.generateStorageUniqueKeyGeneratorOptions();
  checkAndClearSignInTokenExpireTimeStorage(options);
  if (!onLoginSessionExpired) {
    return;
  }
  switch (onLoginSessionExpired) {
    case LoginSessionExpiredBehavior.ForceRefreshRoute:
      (_a = bytecloudContext) == null ? void 0 : _a.forceRefreshMicroFrontend();
      return;
    case LoginSessionExpiredBehavior.ReloadPage:
      window.location.reload();
      return;
    default:
      (_b = bytecloudContext) == null ? void 0 : _b.forceRefreshMicroFrontend();
      return;
  }
}
export {
  clearExpireTimeCacheAndRefresh,
  getDefaultHijackTopSource,
  getGatewayDomainId,
  getGotoVolcUrl,
  getProxyAddHeader,
  gotoVolc,
  policyTCCProxy
};
